import { supabase } from './supabase';
import { Tables } from '../types/database.types';

export type Reality = Tables<'realities'>;

export const realitiesService = {
  // Obtener todos los realities ordenados por display_order
  async getAll(): Promise<Reality[]> {
    const { data, error } = await supabase
      .from('realities')
      .select('*')
      .order('display_order', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  // Obtener un reality por ID
  async getById(id: string): Promise<Reality | null> {
    const { data, error } = await supabase
      .from('realities')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;
    return data;
  },

  // Crear un nuevo reality
  async create(reality: Omit<Reality, 'id' | 'created_at' | 'updated_at'>): Promise<Reality> {
    const { data, error } = await supabase
      .from('realities')
      .insert(reality)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  // Actualizar un reality
  async update(id: string, reality: Partial<Omit<Reality, 'id' | 'created_at' | 'updated_at'>>): Promise<Reality> {
    const { data, error } = await supabase
      .from('realities')
      .update({ ...reality, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  // Activar/Desactivar un reality
  async toggleActive(id: string, active: boolean): Promise<Reality> {
    const { data, error } = await supabase
      .from('realities')
      .update({ active, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  // Eliminar un reality (soft delete cambiando active a false)
  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('realities')
      .update({ active: false, updated_at: new Date().toISOString() })
      .eq('id', id);

    if (error) throw error;
  },
};
